import React from "react";
import Ball from "./Ball";
import { animationConfig } from "./use-float-animation";

const Balls = () => (
  <>
    {times(animationConfig.amountOfObjects).map((i, key) => (
      <Ball key={key} />
    ))}
  </>
);

export default Balls;

const times = (length: number) => Array.from({ length });
